import { isRoomTypePage } from '../urlHelpers'
import { stripLocaleFromPath } from '../localeHelpers'
import { getTable } from './helpers'

export function getSEOPathFromRouteTable (state, routes, pathname) {
  const normalizedPathname = pathname?.startsWith('/') ? pathname : '/' + pathname
  const strippedPathname = stripLocaleFromPath(normalizedPathname).substring(1)
  const isRoomType = strippedPathname && isRoomTypePage('/' + strippedPathname)

  const roomTypePrefix = isRoomType
    ? strippedPathname.split('/').slice(0, 2).join('/')
    : null

  const pathnameForLookup = isRoomType
    ? strippedPathname.split('/').slice(2).join('/')
    : strippedPathname

  const path =
    getSEOPathFromRouteTableAndState(state, routes) ||
    getSEOPathFromRouteTableAndPathname(pathnameForLookup, routes)

  if (roomTypePrefix) {
    return path ? `${roomTypePrefix}/${path}` : roomTypePrefix
  }

  return path
}

export function getSEOPathFromRouteTableAndState (state, routes) {
  if (!state['category_hierarchy.lvl0'] || state['category_hierarchy.lvl0'].length === 0) return null
  const lastHierarchyElement = state['category_hierarchy.lvl0'].slice(-1)[0]
  return routes[slugify(lastHierarchyElement)]
}

export function getSEOPathFromRouteTableAndPathname (pathname, routes) {
  if (!pathname) return null

  // Create a path variable and split the pathname on the '/'
  let path = null
  const arr = pathname.split('/')

  // Loop through the array of paths and find a match in the routes
  // If a valid route is found assign it to the path variable.
  // Continue looping through all paths till we find the last valid route.
  arr.forEach((element) => {
    const route = routes[element]
    if (route) { path = route };
  })

  return path
}

function slugify (name) {
  return name.replace(/ /g, '-').toLowerCase()
}

// change from grey => Grey or wall-art into Wall Art
export function toProperCase (pathElement) {
  if (pathElement === 'chests-of-drawers') return 'Chests of Drawers'
  return pathElement.split('-').map(function (str) { return str.charAt(0).toUpperCase() + str.slice(1) }).join(' ')
}

// ['meubels', 'kasten-en-opbergen'] => ['Meubels', 'Kasten en Opbergen']
// Segments outside the taxonomy (modifiers) fall back to proper-casing
export function categoryNamesFromRoutes (routeElements) {
  const categoryNames = getTable('category-names') || {}
  return routeElements.map((element, index) => {
    return categoryNames[routeElements.slice(0, index + 1).join('/')] || toProperCase(element)
  })
}

// iterate over all the routes and see if we can find a matching modifier
// once we get matching modifier, we can break out of loop and the next element
// in array is a modifier value, pull that out if it exists
// return modifierIndex !== undefined ? [routes[modifierIndex], routes[modifierIndex + 1]] : [null, null];
export function getModifierFromLocation (routes, allModifiers) {
  let modifierIndex = -1
  let modifierKey = null
  let modifierValue = null

  for (const modifier in allModifiers) {
    modifierIndex = routes.findIndex(mod => mod === modifier)
    if (modifierIndex === -1) continue

    modifierKey = allModifiers[modifier]
    modifierValue = toProperCase(routes[modifierIndex + 1])
    return [modifierIndex, modifierKey, modifierValue]
  }
  return [modifierIndex, modifierKey, modifierValue]
}

export function updateCategoryHierarchyFromLocation (modifierIndex, allRoutes, queryParameters) {
  const routeElementsNamed = categoryNamesFromRoutes(allRoutes)
  queryParameters['category_hierarchy.lvl0'] = categoryHierarchyUpToModifier(routeElementsNamed, modifierIndex)
  return queryParameters
}

export function categoryHierarchyUpToModifier (routeElements, modifierIndex) {
  const fullHierarchy = ['category', 'subcategory', 'product_type', 'sub_product_type']
  const noModifier = modifierIndex === -1
  if (noModifier) return routeElements.slice(0, fullHierarchy.length)
  return routeElements.slice(0, modifierIndex)
}
